export const STATUS = {
    SUCCESS: 0,
    FAILED: 1,
    UNAUTHORIZED: 999
}